<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#94FF89" />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { pushToDataLayer } from '~/composables/useTracking';
import { useCartStore } from '~/store/cart';

const uiStore = useUiStore();
const cartStore = useCartStore();
const route = useRoute();
const config = useRuntimeConfig();

// Preload Matomo container for faster loading
useHead({
  link: [
    {
      rel: 'preload',
      href: `/mtm_assets/container_${config.public.matomo.containerId}.js`,
      as: 'script',
    }
  ]
});

/**
 * Navigation guard
 */
const router = useRouter();
router.beforeEach(() => {
  document.body.classList.remove('locked');
  uiStore.tempErrorMsg = '';
  cartStore.showCartMenu = false;
  cartStore.showAddedItem = false;
});

onMounted(() => {
  pushToDataLayer({
    event: 'originalLocation',
    originalLocation: window.location.href,
  });
  if (import.meta.client && route.query?.fbclid) {
    const fbCookie = useCookie<string | null | undefined>('fbBackupCookie', { maxAge: 3600 * 24 * 182, path: '/' });
    fbCookie.value = route.query?.fbclid;
  }
  
  // Auto-open account menu for password reset links
  if (route.query?.id && route.query?.i) {
    cartStore.showAccountMenu = true;
  }
});
</script>
